import { AUTHENTICATION_PLATFORM_FEATURE_CONFIG } from './authentication';
import { RISK_PLATFORM_FEATURE_CONFIG } from './risk';
import { COMMERCIAL_PLATFORM_FEATURE_CONFIG } from './commercial';
import { PRICING_PLATFORM_FEATURE_CONFIG } from './pricing';
import { COMPLIANCE_PLATFORM_FEATURE_CONFIG } from './compliance';

const PLATFORM_FEATURE_CONFIG = {
  BCH: {
    ...AUTHENTICATION_PLATFORM_FEATURE_CONFIG.BCH,
    ...RISK_PLATFORM_FEATURE_CONFIG.BCH,
    ...COMMERCIAL_PLATFORM_FEATURE_CONFIG.BCH,
    ...PRICING_PLATFORM_FEATURE_CONFIG.BCH,
    ...COMPLIANCE_PLATFORM_FEATURE_CONFIG.BCH,
  },
  SANTANDER: {
    ...AUTHENTICATION_PLATFORM_FEATURE_CONFIG.SANTANDER,
    ...RISK_PLATFORM_FEATURE_CONFIG.SANTANDER,
    ...COMMERCIAL_PLATFORM_FEATURE_CONFIG.SANTANDER,
    ...PRICING_PLATFORM_FEATURE_CONFIG.SANTANDER,
    ...COMPLIANCE_PLATFORM_FEATURE_CONFIG.SANTANDER,
  },
  FINGO: {
    ...AUTHENTICATION_PLATFORM_FEATURE_CONFIG.FINGO,
    ...RISK_PLATFORM_FEATURE_CONFIG.FINGO,
    ...COMMERCIAL_PLATFORM_FEATURE_CONFIG.FINGO,
    ...PRICING_PLATFORM_FEATURE_CONFIG.FINGO,
    ...COMPLIANCE_PLATFORM_FEATURE_CONFIG.FINGO,
  },
  ITAU: {
    ...AUTHENTICATION_PLATFORM_FEATURE_CONFIG.ITAU,
    ...RISK_PLATFORM_FEATURE_CONFIG.ITAU,
    ...COMMERCIAL_PLATFORM_FEATURE_CONFIG.ITAU,
    ...PRICING_PLATFORM_FEATURE_CONFIG.ITAU,
    ...COMPLIANCE_PLATFORM_FEATURE_CONFIG.ITAU,
  },
};

export default PLATFORM_FEATURE_CONFIG;
